
import { useParams  } from 'react-router-dom';
import { useBodegaXID } from '../../../hooks';
import { DisenioPaginas } from '../../layout';
import { CargandoMedio, FormCreateUpdateBodega } from '../../components';





export const ActualizarBodega = () => {

    
    const { id } = useParams();
    const { bodegaXIDQuery } = useBodegaXID(`${id}`);
    const bodega = bodegaXIDQuery?.data



    const initialState = (bodega) ? {
        nombre: bodega.nombre || '',
        granja: bodega.granja || '',
        alto: bodega.alto || '',
        ancho: bodega.ancho || '',
        largo: bodega.largo || '',
    } : {};




    return (

        <DisenioPaginas titulo="Actualizar Bodega" url={1} add={false} subtitulo="Información de bodega">
            {(bodegaXIDQuery.isLoading)
            ?   <CargandoMedio titulo="Cargando Bodega..." />
            :   <FormCreateUpdateBodega initialState={initialState} />
            }
        </DisenioPaginas>


    )



}
